<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-list title="Categorías de pago" resource="pago_categorias" primaryKey="idpago_categoria"
        :records="records" :meta="meta" :columns="columns" />
    </div>
  </div>
</template>
<script>
import CardList from "@/components/Cards/CardList.vue";
import Pago_categoriaService from "@/services/pago_categoria.service";
import { pago_categoria } from "@/models/pago_categoria";

export default {
  components: {
    CardList,
  },

  data() {
    return {
      records: null,
      meta: {},
      columns: pago_categoria.filter(column => column.showOnList)
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        Pago_categoriaService.list(this.$route.query)
          .then((data) => {
            this.records = data.records;
            this.meta = data.meta;
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },
};
</script>
